import React from 'react'

const VideoFrame = ({ title, src, className, width, height }) => (
    // Note: Removed loading="lazy" because of conflict with mediavine ads
    <iframe title={title} className={className} width={width} height={height} src={src} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    )

export default VideoFrame